import "core-js/modules/es.promise.js";
import { accessTokenItem, refreshTokenItem } from "./auth-base.vm";
export const persistJwt = data => {
  const {
    refreshToken,
    accessToken
  } = data;
  if (accessToken) localStorage.setItem(accessTokenItem, accessToken);
  if (refreshToken) localStorage.setItem(refreshTokenItem, refreshToken);
};
export const cleanJwt = () => {
  localStorage.removeItem(accessTokenItem);
  localStorage.removeItem(refreshTokenItem);
};
export const promiseJwt = promise => new Promise((resolve, reject) => {
  promise().then(res => {
    persistJwt(res.data);
    resolve(res);
  }).catch(e => reject(e));
});